export const GET_LOYALTY_POINTS_AVAILABILITY_REQUEST =
  'GET_LOYALTY_POINTS_AVAILABILITY_REQUEST';
export const GET_LOYALTY_POINTS_AVAILABILITY_SUCCESS =
  'GET_LOYALTY_POINTS_AVAILABILITY_SUCCESS';

export const LOYALTY_POINTS_AVAILABILITY_REQUESTING =
  'LOYALTY_POINTS_AVAILABILITY_REQUESTING';
export const RESET_LOYALTY_POINTS_AVAILABILITY_ISFETCHING =
  'RESET_LOYALTY_POINTS_AVAILABILITY_ISFETCHING';
